module.exports = __webpack_public_path__ + "static/media/ico_arrow_select.91a95695.svg";